<template>
  <div class="app-convention-hall app-page">
    <van-nav-bar class="app-nav-bar" :title="$t('foorter.subscribe')" />
    <!-- 导航 -->
    <!-- <div class="games-page__nav-box" @click="gotoMenu('/videos')">
      <div class="games-page__nav-left-box">
        <img class="games-page__game-03" src="../../assets/images/shared/game_03.png" alt="">
        <div class="games-page__nav-title">{{ $t('会员视频') }}</div>
      </div>
      <div class="games-page__nav-right-box">
        <div class="games-page__nav-label">{{ $t('海量视频免费观看') }}！</div>
        <div class="games-page__icon-box">
          <div class="games-page__dian-box">

          </div>
          <img class="games-page__game-01" src="../../assets/images/shared/applogo.jpeg" alt="">
        </div>
        <van-icon name="arrow" />
      </div>
    </div> -->

    <!-- <div class="games-page__nav-box" @click="gotoMenu('/videos')">
      <div class="games-page__nav-left-box">
        <img class="games-page__game-03" src="../../assets/images/shared/game_04.png" alt="">
        <div class="games-page__nav-title">{{ $t('会员视频') }}</div>
      </div>
      <div class="games-page__nav-right-box">
        <div class="games-page__nav-label">{{ $t('热情的') }}</div>
        <div class="games-page__icon-box">
          <div class="games-page__dian-box">
          </div>
          <img class="games-page__game-01" src="../../assets/images/shared/vip_video.png" alt="">
        </div>
        <van-icon name="arrow" color="#666" />
      </div>
    </div> -->
    <div class="games-page__nav-box" @click="gotoMenu('/home')">
      <div class="games-page__nav-left-box">
        <img class="games-page__game-03" src="/img/star.svg" alt="">
        <div class="games-page__nav-title">{{ $t('新福利') }}</div>
      </div>
      <div class="games-page__nav-right-box">
        
        <div class="games-page__nav-label">{{ $t('新会员') }}  ID: 087***</div>
        <div class="games-page__icon-box">
          <div class="games-page__dian-box">
          </div>
          <img class="games-page__game-01" src="../../assets/images/shared/new.png" alt="">
        </div>
        <van-icon name="arrow" color="#666" />
      </div>
    </div>

    <img class="games-page__guanfang-img" src="../../assets/images/shared/guanfang.png" alt="">
    <!-- 游戏列表 -->
    <div class="games-page__gamelist-box" v-if="gameitem">
      <div class="games-page__game-item" v-for="(v, key) in gameitem" :key="key" @click="toLottery(v.key, v.id)">
        <!-- <div class="games-page__game-name">{{ v.name }}</div> -->
        <!-- <div class="game_img">
          <van-image class="app-game-item-image" :src="v.ico">
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </div> -->
        
        <van-image class="app-game-item-image" :src="v.ico">
        <!-- <van-image class="app-game-item-image" :src="game_03"> -->
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
      </div>
    </div>



    <div class="games-page__convention-item" v-if="false">
      <div class="app-left">
        <van-sidebar @change="onChange" v-model="activeKey">
          <van-sidebar-item :title="$t('index.all')" />
          <van-sidebar-item v-for="(v, key) in lotteryitem" :key="key" :title="v.name" />
        </van-sidebar>
      </div>
      <div class="app-right">
        <van-pull-refresh :border="false" class="games-page__list-wrapper" v-model="isLoading" @refresh="onRefresh"
          :pulling-text="$t('refresh.pulling')" :loosing-text="$t('refresh.loosing')"
          :loading-text="$t('refresh.loading')">
          <van-grid :column-num="2">
            <van-grid-item @click="toLottery(v.key, v.id)" v-for="(v, key) in gameitem" :key="key">
              <van-image class="app-game-item-image" :src="v.ico">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <span>{{ v.name }}</span>
              <span>{{ v.desc }}</span>
            </van-grid-item>
          </van-grid>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      gameitem: [{}, {}, {}, {}],
      lotteryitem: [{}, {}, {}, {}],
      isLoading: false,
      activeKey: 0,
    };
  },
  methods: {
    gotoMenu(router) {
      this.$router.push(router)
    },
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/auth/login' })
      } else {
        this.$router.push({ path: '/games/lottery?key=' + key + "&id=" + id })
      }
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data: { class: index },
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    getLotteryItem() {
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res => {
        this.lotteryitem = res.data;
      })
    }
  },
  created() {
    this.getGameItem();//获取首页游戏列表
    this.getLotteryItem();
  }
};
</script>

<style lang='less' scoped src="./index.styles.less"></style>
